import { createContext } from 'react';
import { IFileData, IEditApk, TApkType, TParametersOfApkType } from 'types';

export type TTypeOfEditApkModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';
export interface IInitialFormData {
	versionName: string;
	versionCode: string;
	description: string;
	applicationId: string;
	IDSelectedApkType: Nullable<TApkType>;
	isCutoverBeforeUpdate: boolean;
	filePath: string;
}

export interface IEditApkState {
	needRefetchData: boolean;
	initialFormData: IInitialFormData | null;
	apkID: string;
	versionName: string;
	versionCode: string;
	description: string;
	applicationId: string;
	parameterOfApkType: Nullable<TParametersOfApkType>;
	IDSelectedApkType: Nullable<TApkType>;
	isCutoverBeforeUpdate: boolean;
	fileData: IFileData;
	filePath: string;
	dataForSubmit: IEditApk | null;
	typeOfModalWindow: TTypeOfEditApkModalWindow;
}

export const editApkInitialState: IEditApkState = {
	needRefetchData: false,
	initialFormData: null,
	apkID: '',
	versionName: '',
	versionCode: '',
	description: '',
	applicationId: '',
	parameterOfApkType: null,
	IDSelectedApkType: null,
	isCutoverBeforeUpdate: false,
	fileData: {
		fileId: '',
		fileHash: null,
		fileName: '',
	},
	filePath: '',
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditApkContext extends IEditApkState {
	refetchData(value: boolean): void;
	changeVersionName(value: string): void;
	changeVersionCode(value: string): void;
	changeDescription(value: string): void;
	changeApplicationId(value: string): void;
	setParameterOfApkType(value: Nullable<TParametersOfApkType>): void;
	setIDApkType(value: Nullable<TApkType>): void;
	toggleCutoverBeforeUpdate(): void;
	changeFileData(value: IFileData): void;
	setDataForSubmit(value: IEditApk | null): void;
	changeTypeOfModalWindow(value: TTypeOfEditApkModalWindow): void;
	resetFields(): void;
}

export const EditApkContext = createContext<IEditApkContext>({
	refetchData: () => undefined,
	changeVersionName: () => undefined,
	changeVersionCode: () => undefined,
	changeDescription: () => undefined,
	changeApplicationId: () => undefined,
	setParameterOfApkType: () => undefined,
	setIDApkType: () => undefined,
	toggleCutoverBeforeUpdate: () => undefined,
	changeFileData: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...editApkInitialState,
});
